import {Injectable} from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MobileDetectionService {
    constructor(private breakpointObserver: BreakpointObserver) {}

    get isMobile$(): Observable<boolean> {
        return this.breakpointObserver.observe([
            Breakpoints.HandsetPortrait,
            Breakpoints.HandsetLandscape,
            Breakpoints.TabletPortrait
        ]).pipe(
            map(state => state.matches),
        );
    }
}
